import { render, staticRenderFns } from "./scenerios.vue?vue&type=template&id=b2aa83ee"
import script from "./scenerios.vue?vue&type=script&lang=js"
export * from "./scenerios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports